import { Link, router } from '@inertiajs/react'
import type { ReactNode } from 'react'
import Layout from '../../layouts/Layout'
import Button from '../../components/ui/Button'

interface Post {
  id: string
  title: string
  thumbnail: string
  username: string
  userId: string
}

interface Props {
  posts: Post[]
}

export default function Index({ posts }: Props) {
  const handleDelete = (postId: string) => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      router.delete(`/posts/${postId}`)
    }
  }

  return (
    <Layout title="Posts">
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold">Posts</h1>
          <Link href="/posts/new">
            <Button>New Post</Button>
          </Link>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Image
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Title
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  User
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {posts.map((post) => (
                <tr key={post.id}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {post.thumbnail && (
                      <img
                        src={post.thumbnail}
                        alt={post.title || 'Post image'}
                        className="h-12 w-12 rounded object-cover"
                      />
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {post.title || 'Untitled'}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <Link
                      href={`/${post.username}`}
                      className="text-sm text-blue-600 hover:text-blue-800"
                    >
                      @{post.username}
                    </Link>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium space-x-4">
                    <Link
                      href={`/posts/${post.id}`}
                      className="text-gray-600 hover:text-gray-900"
                    >
                      Show
                    </Link>
                    <Link
                      href={`/posts/${post.id}/edit`}
                      className="text-gray-600 hover:text-gray-900"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(post.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {posts.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            No posts yet. Create your first post!
          </div>
        )}
      </div>
    </Layout>
  )
}

Index.layout = (page: ReactNode) => page
